<div class="navbar-nav dropdown justify-content-end">
  <div class="nav-link dropdown-toggle" id="navbarDropdown1" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    <img src="../../../assets/notification.png" title="Notifications" />

    <span *ngIf="unreadNotificationsCount > 0" class="badge rounded-pill badge-notification notification-count">{{
      unreadNotificationsCount >= 10 ? '10+' : unreadNotificationsCount
    }}</span>
  </div>
  <div class="dropdown-menu dropdown-menu-right settings-dropdown" aria-labelledby="navbarDropdown">
    <div class="d-flex user-title-font dropdown-border menu-header">Notifications</div>
    <a class="dropdown-item dropdown-border" *ngFor="let n of notifications">
      <div
        class="menu-text header-read-notification"
        (click)="readNotification(n?.id)"
        [class]="!n.viewed ? 'bold' : ''"
        [innerHTML]="n?.message ?? ''"
        id="userNotificationsReadLink"
      ></div>
    </a>
    <a *ngIf="!notifications" class="dropdown-item">
      <div class="menu-text header-read-notification">No unread notifications</div>
    </a>
    <div *ngIf="notifications" class="m-3 float-right">
      <app-button
        title="View all"
        class="pr-2"
        for="viewAllBtn"
        [small]="true"
        btnType="primary-outline"
        type="submit"
        (click)="goSeeAll(); removeClassToBodyForResponsiveMenu()"
        id="userNotificationsViewAllLink"
        >View all</app-button
      >
      <app-button
        title="Mark all as read"
        for="markAllBtn"
        [small]="true"
        btnType="primary-solid"
        type="submit"
        (click)="markAllNotificationsAsRead()"
        id="userNotificationsMarkAllLink"
        >Mark all as read</app-button
      >
    </div>
  </div>
</div>
